export class CoordinatesModel {
  lat: number;
  lng: number;
  accuracy?: number;

  constructor(that?: CoordinatesModel) {
    if (that) {
      this.lat = +that.lat || this.lat;
      this.lng = +that.lng || this.lng;
      this.accuracy = +that.accuracy || this.accuracy;
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/models/coordinates.model.ts